<script lang="ts" setup>
import type { GameItem } from '@kira-dancer/nuxt-common'
import { SECTION_GAMES_LIMIT } from '~/constants'
import {
  GameLobbyEnum,
  RoutesEnum,
  SlidersPerView,
  GameGroupEnum,
  KeyEnum,
} from '~/enums'
import { HOME_SWIPER_OPTIONS } from '~/resources/game'
import cacheManager from '#lib/utils/cache-manager'

const { isMobile } = useDevice()
const isSwiperLoaded = ref(false)

const swiperOptions = {
  ...HOME_SWIPER_OPTIONS,
  loop: false,
  slidesPerView: isMobile ? SlidersPerView.Mobile : SlidersPerView.Medium,
  spaceBetween: isMobile ? 12 : 24,
}

const { requestFetchGames } = useLobbyGames()

const fetchLobbyGames = async () => {
  const cachedData = cacheManager.get(KeyEnum.GameCard)
  if (cachedData) {
    return cachedData
  }
  try {
    const games = await requestFetchGames({
      cats: GameLobbyEnum.Card,
      limit: SECTION_GAMES_LIMIT,
      groups: GameGroupEnum.Top,
    })
    cacheManager.set(KeyEnum.GameCard, games)
    return games
  } catch {
    return []
  }
}

const { data: lobbyCardGames } = useAsyncData(KeyEnum.GameCard, fetchLobbyGames)

const onSwiper = () => {
  isSwiperLoaded.value = true
}
</script>

<template>
  <div
    v-if="lobbyCardGames?.length"
    :class="{
      'game-bai-section': true,
      'game-bai-section-mobile': isMobile,
    }"
  >
    <BaseSection title="Game bài" icon="icon-game-card">
      <div class="game-bai-section__content">
        <BaseSwiper
          v-show="isSwiperLoaded"
          :items="lobbyCardGames"
          :options="swiperOptions"
          :on-swiper="onSwiper"
        >
          <template #item="{ item }: { item: GameItem }">
            <CommonGameItem :item="item" />
          </template>
        </BaseSwiper>
        <div
          v-show="!isSwiperLoaded"
          class="game-bai-section__placeholder-games"
        >
          <CommonGameItem
            v-for="item in lobbyCardGames"
            :key="item.ID"
            :item="item"
          />
        </div>
      </div>
      <template #right-action>
        <NuxtLink
          :to="RoutesEnum.GameBai"
          class="v-btn v-theme--light v-btn--density-default v-btn--size-small v-btn--variant-text base-button v-btn--text"
          button-id="load-more-game"
          button-name="load-more-game"
        >
          <span class="v-btn__content">Xem thêm</span>
        </NuxtLink>
      </template>
    </BaseSection>
    <DesktopHomeProvider v-if="!isMobile" />
    <MobileHomeProvider v-else />
  </div>
</template>

<style scoped lang="scss">
@import '~/assets/styles/components/desktop/home/game-bai-section.scss';
@import '~/assets/styles/components/responsive/desktop/home/game-bai-section.scss';
</style>
